export default function remove360FromServiceType(name) {
    return name.replace(/\u2013|\u2014|-|[0-9]/g, '').trim();
}
